import { Component, Input, forwardRef, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { UploadService } from '../core';

export const FILE_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FileInputComponent),
  multi: true
};

@Component({
  selector: 'atn-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  providers: [FILE_INPUT_CONTROL_VALUE_ACCESSOR],
  host: { '[class]': '"size-" + size' }
})
export class FileInputComponent implements ControlValueAccessor {
  @Input() name: string = null;
  @Input() label: string = null;
  @Input() size: 's' | 'm' | 'l' | 'xl' = 's';
  @Input() accept: string = '*';

  private _value: any = '';
  private _onTouchedCallback: () => void = () => {};
  private _onChangeCallback: (_: any) => void = () => {};
  public output: any = null;
  public dragover: boolean = false;
  public loading: boolean = false;

  /**
   * Constructor
   */
  constructor(
    private elementRef: ElementRef,
    private uploadService: UploadService
  ) {}

  /**
   * Devolver el valor del componente
   */
  get value(): any { return this._value; };

  /**
   * Establecer el valor del componente
   */
  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this._onChangeCallback(v);
    }
  }

  /**
   * Implemented as part of ControlValueAccessor.
   * TODO: internal
   */
  writeValue(value: any) {
    this._value = value;

    if ((typeof this._value === 'undefined') || (this._value === null) || (this._value === '')) {
      this.output = null;
    } else {
      this.output = this._value;
    }
  }

  /**
   * Implemented as part of ControlValueAccessor.
   * TODO: internal
   */
  registerOnChange(fn: any) {
    this._onChangeCallback = fn;
  }

  /**
   * Implemented as part of ControlValueAccessor.
   * TODO: internal
   */
  registerOnTouched(fn: any) {
    this._onTouchedCallback = fn;
  }

  /**
   * Eliminar fichero
   */
  removeFile(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.value = null;
    this.output = null;
  }

  /**
   * Permitir soltar ficheros sobre el componente
   */
  allowDrop(event: Event) {
    event.preventDefault();
    this.dragover = true;
  }

  /**
   * Quitar el cursor con fichero arrastrado de la zona donde puedes soltar el fichero
   */
  disableDragOver() {
    this.dragover = false;
  }

  /**
   * Soltar el fichero sobre el componente
   */
  dropFile(e) {
    e.preventDefault();
    this.readFileAndUpload(e.dataTransfer.files);
  }

  /**
   * Abrir explorador de archivos
   */
  openExplorer() {
    const explorer = this.elementRef.nativeElement.querySelector('[type=file]');
    explorer.value = '';
    explorer.click();
  }

  /**
   * Seleccionar fichero local con el explorador de archivos
   */
  selectLocalFile(e) {
    e.preventDefault();
    this.readFileAndUpload(e.target.files);
  }

  /**
   * Leer y subir el fichero
   */
  private readFileAndUpload(files) {
    this.dragover = false;

    if (files.length == 1) {
      let reader = new FileReader();

      reader.onload = (e) => {
        this.loading = true;

        this.uploadService.upload(files[0]).subscribe(fileUrl => {
          this.value = fileUrl.data;
          this.output = fileUrl.data;
          this.loading = false;
        });
      };

      reader.readAsDataURL(files[0]);
    }
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/file-input/file-input.component.ts